import styled from "styled-components";

export const GenericSideMenuItemLabelBox = styled.span`
    flex: 1 0 auto;

    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        flex: 0 0 auto;
        line-height: 1.3;
        width: 12.5rem;
    }
`;
